export const commands = {
    HELP:"HELP",
    CLS:"CLS",
    CLEAR_SCREEN: "CLEAR-SCREEN",
    EXIT:"EXIT",
    RELOAD:"RELOAD",
    CLH:"CLH",
    CLEAR_HISTORY:"CLEAR-HISTORY",
    SET_MODE:"SET-MODE"
};

export const modes = {
    EDIT:"EDIT",
    LAYOUT:"LAYOUT",
    VIEW:"VIEW"
};
